import { estIOS, estInstallee } from '../../pwa/register'
import { Carte, Entete, Puce } from '../composants'

export function PageInstallation() {
  const ios = estIOS()
  const installee = estInstallee()

  return (
    <>
      <Entete
        titre="Installer l'application"
        retour
        action={installee ? <Puce ton="ok">Déjà installée</Puce> : undefined}
      />

      <main className="contenu">
        {installee ? (
          <div className="encart encart--info">
            L'application tourne déjà en mode installé. Rien à faire.
          </div>
        ) : (
          <div className="encart encart--alerte">
            Tant que l'application n'est pas installée sur l'écran d'accueil, Safari peut effacer
            vos données après plusieurs jours sans ouverture. L'installation supprime ce risque.
          </div>
        )}

        {ios ? (
          <Carte titre="Sur iPhone / iPad">
            <ol className="pile pile--serree" style={{ paddingLeft: 20, margin: 0 }}>
              <li>Ouvrez cette page dans <strong>Safari</strong> (pas Chrome ni un navigateur in-app).</li>
              <li>Touchez le bouton <strong>Partager</strong> en bas de l'écran (carré avec une flèche vers le haut).</li>
              <li>Faites défiler et choisissez <strong>« Sur l'écran d'accueil »</strong>.</li>
              <li>Validez avec <strong>Ajouter</strong>.</li>
              <li>Lancez désormais l'application depuis son icône, pas depuis Safari.</li>
            </ol>
            <p className="tres-doux" style={{ marginTop: 12 }}>
              iOS ne propose aucune invite automatique d'installation : cette manipulation manuelle
              est le seul moyen.
            </p>
          </Carte>
        ) : (
          <Carte titre="Sur Android / ordinateur">
            <ol className="pile pile--serree" style={{ paddingLeft: 20, margin: 0 }}>
              <li>Ouvrez le menu du navigateur.</li>
              <li>
                Choisissez <strong>« Installer l'application »</strong> ou{' '}
                <strong>« Ajouter à l'écran d'accueil »</strong>.
              </li>
              <li>Validez.</li>
            </ol>
          </Carte>
        )}

        <Carte titre="Fonctionnement hors ligne">
          <p className="doux">
            Une fois la page chargée, l'application fonctionne intégralement sans réseau : saisie,
            consultation et calcul des analyses. Aucune requête n'est faite vers un serveur, y
            compris quand vous êtes connecté.
          </p>
          <p className="doux" style={{ marginTop: 10 }}>
            Vous pouvez le vérifier : activez le mode Avion, fermez complètement l'application,
            puis rouvrez-la.
          </p>
        </Carte>

        <Carte titre="Où sont mes données ?">
          <p className="doux">
            Dans la base locale du navigateur (IndexedDB), sur cet appareil uniquement. Il n'y a ni
            compte, ni serveur, ni synchronisation. Personne d'autre — y compris l'auteur de
            l'application — ne peut y accéder.
          </p>
          <p className="doux" style={{ marginTop: 10 }}>
            Le revers est qu'aucune restauration n'est possible en cas de perte de l'appareil :
            pensez à exporter régulièrement depuis les réglages.
          </p>
        </Carte>
      </main>
    </>
  )
}
